import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray } from '@angular/forms';
import { getRiskColor } from '@extensions/extensions';
import type { ChartData, ChartOptions, TooltipItem } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { FondDistribution, Fund } from '../my-contract.component';

@Component({
  standalone: false,
  selector: 'app-pie-distribution',
  templateUrl: './pie-distribution.component.html',
  styleUrls: ['./pie-distribution.component.scss']
})
export class PieDistributionComponent implements OnInit, OnChanges {
  @Input() distributionFonds: FormArray;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  public chartsOptions: ChartOptions<'doughnut'> = {
    cutout: '0%',
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: false, position: 'left' },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context: TooltipItem<'doughnut'>) => {
            const value = context.parsed as number;
            return `${value}%`;
          },
          title: () => ''
        }
      }
    },
    elements: {
      arc: {}
    }
  };

  public chartData?: ChartData<'doughnut', number[], string>;

  extendedFonds: any[];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.distributionFonds && changes?.distributionFonds.currentValue !== undefined) {
      this.distributionFonds = changes.distributionFonds.currentValue;
      this.initExtandedFonds();
    }
  }

  updateCharts(labels: string[], data: number[], backgroundColors: string[]): void {
    this.chartData = {
      labels,
      datasets: [
        {
          data,
          backgroundColor: backgroundColors
        }
      ]
    };
  }

  getRiskColor = getRiskColor;

  ngOnInit(): void {
    this.distributionFonds.controls.forEach((f: FormArray) => {
      f.valueChanges.subscribe((changes: any) => {
        this.initExtandedFonds();
      });
    });
  }

  initExtandedFonds(): void {
    this.extendedFonds = [];
    let chartLabelsExpanded: string[] = [];
    let chartPercentagesExpanded: number[] = [];
    let chartColorsExpanded: string[] = [];

    this.distributionFonds.controls.forEach((f: FormArray) => {
      let fondDistrib = f.controls as unknown as FondDistribution;

      const fond = fondDistrib.fond.value as Fund;

      chartPercentagesExpanded.push(parseFloat(fondDistrib.fraction.value));
      chartColorsExpanded.push(getRiskColor(fond.risk));
      chartLabelsExpanded.push(fondDistrib.fraction.value);

      this.extendedFonds.push({
        id: fondDistrib.id.value,
        title: fondDistrib.fraction.value,
        isEuro: fondDistrib.id.value === 1,
        description: fondDistrib.fond.value,
        fond: fond
      });
    });

    this.updateCharts(chartLabelsExpanded, chartPercentagesExpanded, chartColorsExpanded);
  }
}
